import { errorLogger } from '@ajaibid/utils';
import fetcher from '@helpers/fetcher';

function getUrl() {
  return `v1/stock-pnl/total-realized`;
}

/**
 * @typedef {import('./typedefs').PnlSummaryResponse}  PnlSummaryResponse
 * @typedef {import('@helpers/fetcher').FetchResponse<PnlSummaryResponse>} Response
 */

/**
 * @param {string} url
 * @param {import('./typedefs').AccountType} accountType
 * @param {import('./typedefs.js').Range} range
 * @returns
 */
function callbackFetch(url, accountType, range) {
  return async () => {
    try {
      /** @type {Response} */
      const res = await fetcher.get(url, {
        params: { type: accountType, range },
      });

      return res.data;
    } catch (err) {
      errorLogger('ERROR_API', err.message);
      throw err;
    }
  };
}

/**
 * @param {import('./typedefs').AccountType} accountType
 * @param {import('./typedefs.js').Range} range
 */
export default function fetch(accountType, range) {
  const url = getUrl();
  const cb = callbackFetch(url, accountType, range);
  const key = [url, accountType, range];

  return { cb, key };
}
